<template>
    <div>
        <div class="input-group mb-3" style="max-width: 300px">
            <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroupFileAddon01">Upload</span>
            </div>
            <div class="custom-file">
                <!-- input, change events will emitted at same time, when input done -->
                <input ref="input" @input="handleInput" type="file" class="custom-file-input" id="inputGroupFile01"
                       aria-describedby="inputGroupFileAddon01" multiple>
                <label class="custom-file-label" for="inputGroupFile01">Choose file</label>
            </div>
        </div>
        <div class="input-group mb-3" style="max-width: 300px">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">Upload</span>
            </div>
            <input @paste="handlePasteAxios" ref="pasteName1" type="text" class="form-control" placeholder="Filename"
                   aria-label="Username" aria-describedby="basic-addon1">
        </div>
        <div class="input-group mb-3" style="max-width: 300px">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon2">Upload</span>
            </div>
            <input @paste="handlePasteFetch" ref="pasteName2" type="text" class="form-control" placeholder="Filename"
                   aria-label="Username" aria-describedby="basic-addon2">
        </div>
    </div>
</template>
<script>
import Vue from "vue";

export default {
    date() {
        return {
            filename: ''
        }
    },
    mounted() {
        const new_id = (id) => `${this._uid}_${id}`;
        let name = this.$el.getAttribute('name');
        if (name) {
            this.$el.removeAttribute('name');
            this.$refs.input.setAttribute('name', name);
        }
        this.$el.querySelectorAll('[id], [for]')
            .forEach((dom, list) => {
                let newValue;
                if (dom.hasAttribute('id')) {
                    newValue = dom.getAttribute('id');
                    dom.setAttribute('id', new_id(newValue));
                }
                if (dom.hasAttribute('for')) {
                    newValue = dom.getAttribute('for');
                    dom.setAttribute('for', new_id(newValue));
                }
            });
        this.handleInput();
    },
    methods: {
        handlePasteAxios(event) {
            let counter = 0, filename = event.target.value || Date.now(),
                maximum = 3, items, file, apiURL = `${base_url}/api/files?name=${filename}`,
                XSRFTOKEN = document.cookie.valueOf('XSRF-TOKEN').match(/^XSRF-TOKEN=(.*)$/)[1];
            if (event instanceof ClipboardEvent) {
                console.log('Got ClipboardEvent!', event);
                if (event.clipboardData instanceof DataTransfer) {
                    items = event.clipboardData.items;
                    if (items instanceof DataTransferItemList) {
                        for (let item of items) {
                            // console.log(item.kind, item.type, item.kind === 'file');
                            // kind is 'string' of 'file', type is mime-type
                            if (item.kind === 'file') {
                                counter++; // only count file
                                if (counter === maximum) return; // stop when up to maximum
                                file = item.getAsFile();
                                // console.log(event.target.value, this.$refs.pasteName1.value);
                                // both work as expect

                                // 這個 uri 可以 work 也很奇怪
                                // axios.post(`api/files?name=${filename}`, file);
                                // 他會是 http://127.0.0.1/playground/api/files?name=${filename}
                                // 也會是 https://playground.andychen.nataliemarkting.com/api/files?name=${filename}

                                // 正常來說我會用這樣的寫法
                                // axios.post(`${base_url}/api/files?name=${filename}`, file);
                                // 而且 base_url 宣告在 bootstrap.js 裡面, 由 laravel 從 server-side 傳到 html 上

                                axios.post(`${apiURL}`, file)
                                    .then(response => this.$emit('newFile', response.data))
                                    .catch((error) => {
                                        let {response} = error,
                                            {data} = response,
                                            {message} = data;
                                        if (message) {
                                            Vue.notify({message, class: 'danger'});
                                        } else {
                                            console.log([error]);
                                        }
                                    });
                            } else {
                                console.log(item.kind);
                            }
                        }
                    } else {
                        console.log('...items not DataTransferItemList.', items);
                    }
                } else {
                    console.log('event.ClipboardData not DataTransfer.', event.clipboardData);
                }
            } else {
                console.log('Got Event, but not ClipboardEvent!', event);

            }
        },
        handlePasteFetch(event) {
            let counter = 0, filename = event.target.value || Date.now(),
                maximum = 3, items, file, apiURL = `${base_url}/api/files?name=${filename}`,
                XSRFTOKEN = decodeURIComponent(document.cookie.valueOf('XSRF-TOKEN').match(/^XSRF-TOKEN=(.*)$/)[1]);
            if (event instanceof ClipboardEvent) {
                console.log('Got ClipboardEvent!', event);
                if (event.clipboardData instanceof DataTransfer) {
                    items = event.clipboardData.items;
                    if (items instanceof DataTransferItemList) {
                        for (let item of items) {
                            // console.log(item.kind, item.type, item.kind === 'file');
                            // kind is 'string' of 'file', type is mime-type
                            if (item.kind === 'file') {
                                counter++; // only count file
                                if (counter === maximum) return; // stop when up to maximum
                                file = item.getAsFile();
                                // console.log(event.target.value, this.$refs.pasteName1.value);
                                // both work as expect

                                // 這個 uri 可以 work 也很奇怪
                                // axios.post(`api/files?name=${filename}`, file);
                                // 他會是 http://127.0.0.1/playground/api/files?name=${filename}
                                // 也會是 https://playground.andychen.nataliemarkting.com/api/files?name=${filename}

                                // 正常來說我會用這樣的寫法
                                // axios.post(`${base_url}/api/files?name=${filename}`, file);
                                // 而且 base_url 宣告在 bootstrap.js 裡面, 由 laravel 從 server-side 傳到 html 上

                                fetch(`${apiURL}`, {
                                    headers: {
                                        "X-Requested-With": "XMLHttpRequest",
                                        "X-XSRF-Token": XSRFTOKEN
                                    }, method: 'POST', body: file
                                })
                                    .then(response => response.json().then(data => this.$emit('newFile', data)))
                                    .catch((error) => {
                                        // not work since `fetch` reject return `<never>` parameter
                                        let {response} = error,
                                            {data} = response,
                                            {message} = data;
                                        if (message) {
                                            Vue.notify({message, class: 'danger'});
                                        } else {
                                            console.log([error]);
                                        }
                                    });
                            } else {
                                console.log(item.kind);
                            }
                        }
                    } else {
                        console.log('...items not DataTransferItemList.', items);
                    }
                } else {
                    console.log('event.ClipboardData not DataTransfer.', event.clipboardData);
                }
            } else {
                console.log('Got Event, but not ClipboardEvent!', event);

            }
        },
        handleInput(event) {
            let maximum = 3;
            let counter = 0;
            if (event === undefined) {
                return;
            }
            let files = event.target.files,
                promises = [], send_files = [];
            for (const file of files) {
                counter++;
                if (counter > maximum) return;

                // send multiple files in same request not success yet
                // if (file instanceof File) {
                //     send_files.push({name: file.name});
                //     promises.push(file.arrayBuffer());
                // }

                axios.post(`api/files?name=${file.name}`, file)
                    .then(response => this.$emit('newFile', response.data))
                    .catch((...result) => console.log(result));
                // fetch('api/files', {method: 'post', body: file})
                //     .then(response => response.body.getReader().read().then(console.log))
            }

            // send multiple files in same request not success yet
            // Promise.all(promises).then(arrayBuffers => {
            //     arrayBuffers.forEach((ab, ind, total) => {
            //         send_files[ind]['content']= new Blob([new Uint8Array(ab)]);
            //     });
            //
            //     console.log(send_files);
            //     axios.post('api/files', {files: send_files})
            //         .then(console.log)
            //         .catch((...result) => console.log(result));
            // });
            console.log(send_files);
        }
    }
}
</script>
